<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
            :small="small"
            icon
            v-on="{ ...onTooltip, ...on }"
          >
            <v-icon :small="small">
              mdi-currency-usd
            </v-icon>
          </v-btn>
        </template>
        <span>Preço target</span>
      </v-tooltip>
    </template>
    <v-card class="mx-auto"
            max-width="400">
      <v-container>
        <v-row dense>
          <v-col cols="12">
            <div>
              <p class="mb-1 font-weight-bold caption">Preco Target:</p>
              <p class="large-text mb-1">{{ produto.produto.precoTarget
              | currency('R$', produto.produto.casasDecimais) | naoInformado }}</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    produto: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
};
</script>
